import React, { FC } from 'react';

import Flex from '@rover/kibble/core/Flex';

import useFooterShim from '../../../../hooks/useFooterShim';

import MarketingSocialIcon from './MarketingSocialIcon';

const MarketingSocial: FC = () => {
  const { footer } = useFooterShim();
  const { marketingSocial } = footer || {};

  if (!marketingSocial) return null;

  return (
    <Flex mt="0x" mb="0x" justifyContent={['center', 'center', 'flex-start']}>
      {marketingSocial.items
        .filter((item) => !!item.icon)
        .map((item) => (
          <MarketingSocialIcon key={item.name} brandIcon={item.icon} href={item.url} />
        ))}
    </Flex>
  );
};

export default MarketingSocial;
